module.exports = __webpack_public_path__ + "assets/media/logo-row.8ee7278b.jpg";